import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../shared/context/AuthContext";
import "../../../styles/features/auth/login.css";
import {
  getPostLoginContext,
} from "../../share-links/utils/shareAccessSession";
import { consumePostLoginRedirect } from "../utils/postLoginRedirect";
import LoginBoxContent from "../components/LoginBoxContent";

const SHARE_LOGIN_REASONS = new Set(["share_open", "private_resource"]);

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoginModalVariant } = useAuth();
  const [loginContext, setLoginContext] = useState(null);

  useEffect(() => {
    if (typeof setLoginModalVariant === "function") {
      setLoginModalVariant("session-expired");
    }
  }, [setLoginModalVariant]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const reason = searchParams.get("reason");
    if (!SHARE_LOGIN_REASONS.has(reason)) {
      setLoginContext(null);
      return;
    }
    setLoginContext(getPostLoginContext() || { reason });
  }, [location.search]);

  return (
    <div className="login-container">
      <LoginBoxContent
        loginContext={loginContext}
        onLoginSuccess={() => {
          const redirected = consumePostLoginRedirect(navigate);
          if (!redirected) {
            navigate("/");
          }
        }}
      />
    </div>
  );
};

export default Login;
